import { ShopItem, ShopItemForStoreData } from '@shared/api/shopItem/shopItem.interface';

import { Image } from '../media/media.interface';
import { ShopItemInfo } from '../shopItemInfo/shopItemInfo.interface';

type ShopItemLike =
  | ShopItem<ShopItemInfo<string, Image>, string, string, Image>
  | ShopItemForStoreData;

//* 상조별 판매 레코드(shopItem)의 덮어쓴 값 우선, 없으면 원상품(shopItemInfo) 값 — 이름·이미지 공통 규칙
export const getShopItemImageUrl = (shopItem: ShopItemLike) => {
  return shopItem.image?.url ?? shopItem.shopItemInfo.image?.url;
};

export const getShopItemName = (shopItem: ShopItemLike): string =>
  shopItem.name ?? shopItem.shopItemInfo.name;

//* 표시 이름: "[근조3단]화환" 처럼 대괄호 접두 뒤 공백을 하나로 정규화 → "[근조3단] 화환"
export const getShopItemDisplayName = (shopItem: ShopItemLike): string =>
  getShopItemName(shopItem).replace(/^(\[[^\]]+\])\s*/, '$1 ');
